import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, useParams, useNavigate } from "react-router-dom";

import SettingsPage from '../partials/SettingsPage';
import LoadingSpinner from '../partials/LoadingSpinner';
import PageHeader from '../partials/PageHeader';

import AddSupplierAssignmentModal from './AddSupplierAssignmentModal';
import UpdateSupplierAssignmentModal from './UpdateSupplierAssignmentModal';
import DeleteSupplierAssignmentModal from './DeleteSupplierAssignmentModal';

import { Button, Text, Small, Panel, H3, H4, Dropdown, Input, Tabs, Datepicker, Textarea, Box } from '@bigcommerce/big-design';
import { AddIcon, ArrowDropDownIcon } from '@bigcommerce/big-design-icons';

import { purchaseOrdersCreate, purchaseOrderAddItem, purchaseOrderUpdateQuantity } from '../../redux/actions/purchaseOrders';
import { reset } from '../../redux/actions/purchaseOrderLines';
import { suppliersIndex } from '../../redux/actions/suppliers';
import { taxSettingsIndex } from '../../redux/actions/taxSettings';
import { paymentTermsIndex } from '../../redux/actions/paymentTerms';
import { paymentMethodsIndex } from '../../redux/actions/paymentMethods';
import { locationsIndex } from '../../redux/actions/locations';
// import { orderWithShipments } from '../../redux/actions/incompleteOrders';

import { findSuggestedPurchaseOrder, markComplete } from '../../redux/actions/suggestedPurchaseOrders';


import AssignmentList from './AssignmentList';
import ProductSearch from './ProductSearch';
import ProductScan from './ProductScan';
import PurchaseOrderLine from './PurchaseOrderLine';
import PurchaseOrderTotals from './PurchaseOrderTotals';

const NewSuggestedPurchaseOrderForm = ({ 
  payload,
  newPurchaseOrder,
  taxSettings,
  paymentTerms,
  paymentMethods,
  suppliers,
  products,
  loadTaxSettings,
  loadPaymentTerms,
  loadPaymentMethods,
  loadSuppliers,
  locations,
  loadLocations,
  // loadOrder,
  loadSuggestedOrder,
  addPurchaseOrder,
  purchaseOrderLines,
  // activeOrder,
  activeSuggestedPurchaseOrder,
  incompleteOrders,
  clearPOLines,
  addItem,
  quantityUpdate,
  markSuggestionComplete,
  settings
}) => {
  const { suggestedOrderId } = useParams();

  let navigate = useNavigate();

  const [activeSupplier, setActiveSupplier] = useState(null);
  const [activeShippingAddress, setActiveShippingAddress] = useState(null);
  const [activePaymentTerm, setActivePaymentTerm] = useState(null);
  const [activePaymentMethod, setActivePaymentMethod] = useState(null);
  const [activeTaxSetting, setActiveTaxSetting] = useState(null);

  const [invoiceNumber, setInvoiceNumber] = useState(null);
  const [supplierOrderNumber, setSupplierOrderNumber] = useState(null);
  const [notes, setNotes] = useState(null);

  const [adjustedTotal, setAdjustedTotal] = useState(null);
  const [shippingTotal, setShippingTotal] = useState(null);
  const [expectedDate, setExpectedDate] = useState(null);
  const [paymentDate, setPaymentDate] = useState(null);

  const [submitted, setSubmitted] = useState(false);

  const [showAddSupplierAssignmentModal, setShowAddSupplierAssignmentModal] = useState(false);
  const [modalProductId, setModalProductId] = useState(null);
  const [modalVariantId, setModalVariantId] = useState(null);
  const [modalOptions, setModalOptions] = useState(null);
  const [modalProductName, setModalProductName] = useState(null);
  const [modalType, setModalType] = useState(null);
  const [modalAssignment, setModalAssignment] = useState(null);

  const [warnings, setWarnings] = useState({ moq: {}, orderMultiple: {} });

  const setOrderLines = () => {
    clearPOLines();

    if(activeSuggestedPurchaseOrder) {
      let variant = null;
      let product = null;

      activeSuggestedPurchaseOrder.suggested_purchase_order_lines.suggested_purchase_order_lines.forEach(lineItem => {
        variant = null;
        product = null;

        if(lineItem.variant_id) {
          variant = activeSuggestedPurchaseOrder.suggested_purchase_order_lines.variant_data.find(variant_data => variant_data.id === parseInt(lineItem.variant_id));
          product = activeSuggestedPurchaseOrder.suggested_purchase_order_lines.related_product_data.find(prod => prod.id === parseInt(lineItem.product_id));
        } else {
          product = activeSuggestedPurchaseOrder.suggested_purchase_order_lines.product_data.find(prod => prod.id === parseInt(lineItem.product_id));
        }

        let lineObject = {
          imageUrl: variant?.image_url || product?.primary_image?.url_tiny,
          fullImageUrl: variant?.full_image_url || product?.primary_image?.url_standard,
          minimumOrder: lineItem?.minimum_order_quantity,
          options: variant?.option_values,
          productId: lineItem?.product_id,
          productName: product?.name,
          name: product?.name,
          sku: variant?.sku || product?.sku,
          supplier_price: lineItem?.supplier_price || 0.0,
          supplier_sku: lineItem?.supplier_sku,
          upc: variant?.upc || product?.upc,
          variantId: lineItem?.variant_id,
        }

        if(settings?.settings?.pack_quantities) {
          lineObject.packQuantity = lineItem?.pack_quantity;
        }

        addItem(payload, lineObject);

        quantityUpdate(payload, lineItem.recommended_quantity, lineItem.product_id + '/' + lineItem.variant_id);

        let newWarnings = { ...warnings };

        if(parseInt(lineItem?.minimum_order_quantity) > lineItem.recommended_quantity) {
          newWarnings.moq[lineItem.product_id + '/' + lineItem.variant_id] = `${product?.name} line quantity below MOQ: ${lineItem?.minimum_order_quantity} vs. ${lineItem.recommended_quantity}`
          setWarnings(newWarnings);
        }
      })
    }
  };

  useEffect(() => {
    clearPOLines();

    loadTaxSettings(payload);
    loadPaymentTerms(payload);
    loadPaymentMethods(payload);
    loadSuppliers(payload);
    loadLocations(payload);

    loadSuggestedOrder(payload, suggestedOrderId);
  }, []);

  useEffect(() => {
    let newWarnings = { moq: {}, orderMultiple: {} };

    purchaseOrderLines.lineItems.forEach(lineItem => {
      let itemKey = lineItem.productId + '/' + lineItem.variantId;

      if(parseInt(lineItem.minimumOrder) > purchaseOrderLines.lineDetails[itemKey].quantity) {
        newWarnings.moq[itemKey] = `${lineItem.name || lineItem.productName} line quantity below MOQ: ${lineItem.minimumOrder} vs. ${purchaseOrderLines.lineDetails[itemKey].quantity}`
      }

      if(settings?.settings?.order_multiples) {
        if(lineItem.orderMultiple && ((purchaseOrderLines.lineDetails[itemKey].quantity % lineItem.orderMultiple) !== 0)) {
          newWarnings.orderMultiple[lineItem.productId + '/' + lineItem.variantId] = `${lineItem.name || lineItem.productName} line not divisible by assignment order multiple: ${lineItem.orderMultiple}`
        }
      }
    });

    setWarnings(newWarnings);
  }, [purchaseOrderLines]);

  useEffect(() => {
    if(activeSuggestedPurchaseOrder) {
      if(locations.status === 'success') {
        let location = locations.locations.find(loc => loc.id === activeSuggestedPurchaseOrder.location_id)
        activateLocation(location);
      }
      if(suppliers.status === 'success') {
        let supplier = suppliers.suppliers.find(sup => sup.id === activeSuggestedPurchaseOrder.supplier_id)
        activateSupplier(supplier);
      }

      setOrderLines();
    }
  }, [activeSuggestedPurchaseOrder])


  useEffect(() => {
    if(activeSuggestedPurchaseOrder && suppliers.status === 'success') {
      let supplier = suppliers.suppliers.find(sup => sup.id === activeSuggestedPurchaseOrder.supplier_id)
      activateSupplier(supplier);
    }
  }, [suppliers]);

  useEffect(() => {
    if(activeSuggestedPurchaseOrder && locations.status === 'success') {
      let location = locations.locations.find(loc => loc.id === activeSuggestedPurchaseOrder.location_id)
      activateLocation(location);
    }
  }, [locations]);

  useEffect(() => {
    if(newPurchaseOrder) { navigate(-1) };
  }, [newPurchaseOrder]);

  const purchaseOrderJson = () => {
    return {
      supplier: activeSupplier,
      shipping_address: activeShippingAddress,
      payment_term: activePaymentTerm,
      payment_method: activePaymentMethod,
      invoice_number: invoiceNumber,
      tax_setting: activeTaxSetting,
      supplier_order_number: supplierOrderNumber,
      notes: notes,
      invoice_date: invoiceDate,
      adjusted_total: adjustedTotal,
      shipping_total: shippingTotal || 0.0,
      expected_date: expectedDate,
      payment_due_date: paymentDate
    }
  }

  const purchaseOrderLinesJson = () => {
    let orderLines = [];

    purchaseOrderLines?.lineItems?.forEach(purchaseOrderLine => {
      let key = purchaseOrderLine.productId + '/' + purchaseOrderLine.variantId;
      let lineWithDetails = {...purchaseOrderLine};
      lineWithDetails.line_details = purchaseOrderLines.lineDetails[key];
      orderLines.push(lineWithDetails);
    })

    // console.log(orderLines);

    return orderLines;
  }

  const setFieldValue = (setField, event) => {
    let value = event.target.value;
    setField(value);
  }

  const setDropdownValue = (setField, value) => {
    setField(value);
  }

  const activateSupplier = (supplier) => {
    setActiveSupplier(supplier);
    setActivePaymentTerm(paymentTerms.paymentTerms.find(term => term.id === supplier.payment_terms_id));
    setActivePaymentMethod(paymentMethods.paymentMethods.find(method => method.id === supplier.payment_method_id));
    setActiveTaxSetting(taxSettings.taxSettings.find(setting => setting.id === supplier.tax_setting_id));

    if(supplier.shipping_days) {
      let expected = new Date();

      expected.setDate(expected.getDate() + parseInt(supplier.shipping_days));

      const yyyy = expected.getFullYear();
      let mm = expected.getMonth() + 1; // months start at 0
      let dd = expected.getDate();

      if (dd < 10) dd = '0' + dd;
      if (mm < 10) mm = '0' + mm;

      let formattedExpected = yyyy + '-' + mm + '-' + dd + 'T05:00:00.000Z';


      setExpectedDate(formattedExpected);
    }
  }

  const activateLocation = (location) => {
    setActiveShippingAddress(location);
  }

  const paymentTermsItems = () => {
    let items = [];

    paymentTerms.paymentTerms.map(paymentTerm => 
      items.push(
        {
          content: paymentTerm.term_name,
          onItemClick: () => setDropdownValue(setActivePaymentTerm, paymentTerm),
          hash: paymentTerm.id
        }
      )
    )

    return items;
  }

  const paymentMethodsItems = () => {
    let items = [];

    paymentMethods.paymentMethods.map(paymentMethod => 
      items.push(
        {
          content: paymentMethod.method_name,
          onItemClick: () => setDropdownValue(setActivePaymentMethod, paymentMethod),
          hash: paymentMethod.id
        }
      )
    )

    return items;
  }

  const taxSettingsItems = () => {
    let items = [];

    taxSettings.taxSettings.map(taxSetting => 
      items.push(
        {
          content: taxSetting.tax_name,
          onItemClick: () => setDropdownValue(setActiveTaxSetting, taxSetting),
          hash: taxSetting.id
        }
      )
    )

    return items;
  }

  const handleSubmit = () => {
    setSubmitted(true);
    markSuggestionComplete(payload, suggestedOrderId);
    addPurchaseOrder(payload, purchaseOrderJson(), purchaseOrderLinesJson());
  }

  const validPO = () => {
    let block = !(activeShippingAddress && activePaymentTerm && activePaymentMethod && activeTaxSetting && expectedDate && paymentDate && invoiceDate && (purchaseOrderLines?.lineItems.length > 0))

    if(settings?.settings?.warnings_block) {
      if (Object.keys(warnings.moq).length > 0 || Object.keys(warnings.orderMultiple).length > 0) {
        block = true;
      }
    }

    return block;
  }

  const description = () => {
    return(
      <> 
        <Text>From this page, you can create a purchase order from your suggested purchase order.</Text>
        <Text>Set payment terms, a payment method and tax settings from their respective dropdowns. If options are missing, you can add them by going to the <Link to="/settings">Settings page</Link>.</Text>
        <Text>
          Add product/variant lines to this purchase order by selecting from a paginated set of products assigned to the selected supplier in the "List Supplier Assignments" tab, by searching BigCommerce in the "Search BigCommerce" tab, or by scanning barcodes in the "Scan Barcodes" tab.
          If products are missing from this supplier, you can add them by going to the <Link to="/assignments">Supplier Assignments page</Link>.
        </Text>
        <Text>Add additional information and notes in the "Totals, Adjustments and Dates" panel, then create the purchase order by clicking the "Create Purchase Order" button.</Text>
        <Small>Have questions or need some help? Contact us at <a href="mailto:support@athousandapps.com">support@athousandapps.com</a></Small>
      </>
    )
  }

  const today = () => {
    const today = new Date();
    const yyyy = today.getFullYear();
    let mm = today.getMonth() + 1; // months start at 0
    let dd = today.getDate();

    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;

    let todayDate = yyyy + '-' + mm + '-' + dd + 'T05:00:00.000Z';

    return todayDate;
  }

  const [invoiceDate, setInvoiceDate] = useState(today());

  const setInvoiceD = (value) => {
    setInvoiceDate(value);
  }

  const nextYear = () => {
    const today = new Date();
    const yyyy = today.getFullYear() + 1;
    let mm = today.getMonth() + 1; // months start at 0
    let dd = today.getDate();

    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;

    let next = mm + '/' + dd + '/' + yyyy;

    return next;
  }

  return(
    <>
      <PageHeader stripeBackground='#c66628' helpLink="bigcommerce/create-and-update-purchase-orders/" />
      <SettingsPage title="Purchase Orders" description={description()}>
        <Panel>
          <H3>Suggested Purchase Order</H3>

          <Panel>
            { (suppliers.isFetching || paymentTerms.status !== 'success' || paymentMethods.status !== 'success' || taxSettings.status !== 'success') &&
              <LoadingSpinner statusText="Loading Suppliers" />
            }

            { suppliers.status === 'success' && paymentTerms.status === 'success' && paymentMethods.status === 'success' && taxSettings.status === 'success' && suppliers.suppliers.length > 0 &&
              <>
                
              </>
            }
            
            <div className="flex-container">
              { activeSupplier && 
                <div className="flex-1">
                  <H3>Supplier: { activeSupplier.supplier_name }</H3>
                  <H4>Address</H4>
                  <Text>{activeSupplier.address.company ? `${activeSupplier.address.company} - ` : ''}{activeSupplier.address.first_name} {activeSupplier.address.last_name}
                  <br/>
                  {activeSupplier.address.street_1}
                  { activeSupplier.address.street_2 &&
                    <>
                      <br/>
                      {activeSupplier.address.street_2}
                    </>
                  }
                  <br/>
                  {activeSupplier.address.city}, {activeSupplier.address.state}
                  <br/>
                  {activeSupplier.address.zip}</Text>
                </div>
              }
              
              <div className="flex-1 text-right left-15">
                { activeShippingAddress && 
                  <>
                    <H3>Ship To Address: { activeShippingAddress?.label }</H3>
                    <H4>Address</H4>
                    <Text>{activeShippingAddress.company ? `${activeShippingAddress.company} - ` : ''}{activeShippingAddress.first_name} {activeShippingAddress.last_name}
                    <br/>
                    {activeShippingAddress.street_1 || activeShippingAddress?.address?.address1}
                    { (activeShippingAddress.street_2 || activeShippingAddress?.address?.address2) &&
                      <>
                        <br/>
                        {activeShippingAddress.street_2 || activeShippingAddress?.address?.address2}
                      </>
                    }
                    <br/>
                    {activeShippingAddress.city || activeShippingAddress?.address?.city}, {activeShippingAddress.state || activeShippingAddress?.address?.state}
                    <br/>
                    {activeShippingAddress.zip || activeShippingAddress?.address?.zip}</Text>
                  </>
                }
              </div>
            </div>
        </Panel>

          <Panel>
            <H3>Purchase Order Information</H3>

            <div className="flex-container space-between">
              { paymentTerms.status === 'success' &&
                <div className="flex-1">
                  <H4>Payment Terms</H4>
                  <Dropdown
                    items={paymentTermsItems()}
                    maxHeight={250}
                    placement="bottom-start"
                    toggle={<Button iconRight={<ArrowDropDownIcon />}>{activePaymentTerm?.term_name || "Payment Terms"}</Button>}
                  />
                </div>
              }

              { paymentMethods.status === 'success' &&
                <div className="flex-1">
                  <H4>Payment Method</H4>
                  <Dropdown
                    items={paymentMethodsItems()}
                    maxHeight={250}
                    placement="bottom-start"
                    toggle={<Button iconRight={<ArrowDropDownIcon />}>{activePaymentMethod?.method_name || "Payment Method"}</Button>}
                  />
                </div>
              }

              { taxSettings.status === 'success' &&
                <div className="flex-1">
                  <H4>Tax Settings</H4>
                  <Dropdown
                    items={taxSettingsItems()}
                    maxHeight={250}
                    placement="bottom-start"
                    toggle={<Button iconRight={<ArrowDropDownIcon />}>{activeTaxSetting?.tax_name || "Tax Setting"}</Button>}
                  />  
                </div>
              }
            </div>

            <hr/>

            <Input 
              required 
              label={`${settings.settings['invoice_number_override'] || "Invoice Number"}`}
              placeholder={`${settings.settings['invoice_number_override'] || "Invoice Number"}`}
              id="invoice_number" 
              type="text" 
              value={invoiceNumber} 
              onChange={(e) => setFieldValue(setInvoiceNumber, e)} 
            />

            <Input 
              required 
              label={`${settings.settings['purchase_order_number_override'] || "Purchase Order Number"}`}
              placeholder={`${settings.settings['purchase_order_number_override'] || "Purchase Order Number"}`}
              id="supplier_order_number" 
              type="text" 
              value={supplierOrderNumber} 
              onChange={(e) => setFieldValue(setSupplierOrderNumber, e)} 
            />
          </Panel>
          

          <Panel>
            <H3>Suggested Purchase Order Lines</H3>
            { purchaseOrderLines?.lineItems?.map(purchaseOrderLine => 
              <PurchaseOrderLine
                purchaseOrderLine={purchaseOrderLine}
                purchaseOrderType={'restock'}

                setModalProductId={setModalProductId}
                setModalVariantId={setModalVariantId}
                setModalOptions={setModalOptions}
                setModalProductName={setModalProductName}
                setModalType={setModalType}
                setModalAssignment={setModalAssignment}
                setShowAddSupplierAssignmentModal={setShowAddSupplierAssignmentModal}
                activeSupplier={activeSupplier}
                showSuggestionLevels={true}
              />
            )}
            
          </Panel>
          

          <Panel>
            <H3>Totals, Adjustments and Dates</H3>
            <div className="flex-container">
              <div className="flex-1">
                <H4>Significant Dates</H4>
                <Datepicker
                  required
                  label="Invoice Date"
                  locale="en-GB"
                  max={nextYear()}
                  min={today()}
                  onDateChange={(value) => setInvoiceD(value)}
                  value={invoiceDate}
                />

                <Datepicker
                  required
                  label="Expected Date"
                  locale="en-GB"
                  max={nextYear()}
                  min={today()}
                  onDateChange={(value) => setExpectedDate(value)}
                  value={expectedDate}
                />

                <Datepicker
                  required
                  label="Payment Due Date"
                  locale="en-GB"
                  max={nextYear()}
                  min={today()}
                  onDateChange={(value) => setPaymentDate(value)}
                  value={paymentDate}
                />
              </div>

              <PurchaseOrderTotals
                purchaseOrderLines={purchaseOrderLines}
                activeSupplier={activeSupplier}
                taxSetting={activeTaxSetting}
                adjustedTotal={adjustedTotal}
                shippingTotal={shippingTotal}
                setAdjustedTotal={setAdjustedTotal}
                setShippingTotal={setShippingTotal}
              />
            </div>
          </Panel>
          

          <Panel>
            <Textarea
              description="Order notes"
              label="Order Notes"
              onChange={(e) => setFieldValue(setNotes, e)}
              placeholder="Notes"
              resize={false}
              rows={3}
              value={notes}
            />
          </Panel>
        

          <Button 
            iconLeft={<AddIcon />}
            onClick={() => handleSubmit()}
            disabled={validPO() || submitted}
          >
            Create Purchase Order
          </Button>

          { activeSupplier && !activeShippingAddress &&
            <Text color="danger50">Purchase Order Must Specify a Shipping Address</Text>
          }
          { activeSupplier && !activePaymentTerm &&
            <Text color="danger50">Purchase Order Must Specify a Payment Term</Text>
          }
          { activeSupplier && !activePaymentMethod &&
            <Text color="danger50">Purchase Order Must Specify a Payment Method</Text>
          }
          { activeSupplier && !activeTaxSetting &&
            <Text color="danger50">Purchase Order Must Specify a Tax Setting</Text>
          }
          { activeSupplier && !invoiceDate &&
            <Text color="danger50">Purchase Order Must Include an Invoice Date</Text>
          }
          { activeSupplier && !expectedDate &&
            <Text color="danger50">Purchase Order Must Include an Expected Date</Text>
          }
          { activeSupplier && !paymentDate &&
            <Text color="danger50">Purchase Order Must Include an Expected Payment Date</Text>
          }
          { activeSupplier && !(purchaseOrderLines?.lineItems.length > 0) &&
            <Text color="danger50">Purchase Order Must Include Purchase Items</Text>
          }
          { Object.keys(warnings.moq).map(warningId => 
            <>
              <Text color="warning60">{warnings.moq[warningId]}</Text>
            </>
            )
          }
          { Object.keys(warnings.orderMultiple).map(warningId => 
            <>
              <Text color="warning60">{warnings.orderMultiple[warningId]}</Text>
            </>
            )
          }
        </Panel>
      </SettingsPage>

      { showAddSupplierAssignmentModal && 
        <AddSupplierAssignmentModal
          payload={payload}
          showAddSupplierAssignmentModal={showAddSupplierAssignmentModal}
          setShowAddSupplierAssignmentModal={setShowAddSupplierAssignmentModal}
          supplier={activeSupplier}
          modalProductId={modalProductId}
          modalVariantId={modalVariantId}
          modalOptions={modalOptions}
          modalProductName={modalProductName}
          modalType={modalType}
        />
      }
    </>
  )

}


const mapStateToProps = state => ({
  suppliers: state.suppliers,
  newPurchaseOrder: state.purchaseOrders.newPurchaseOrder,
  taxSettings: state.taxSettings,
  paymentTerms: state.paymentTerms,
  locations: state.locations,
  paymentMethods: state.paymentMethods,
  purchaseOrderLines: state.purchaseOrderLines,
  incompleteOrders: state.incompleteOrders,
  // activeOrder: state.incompleteOrders.activeOrder,
  activeSuggestedPurchaseOrder: state.suggestedPurchaseOrders.activeSuggestedPurchaseOrder,
  products: state.products,
  settings: state.settings,
});

const mapDispatchToProps = (dispatch) => ({
  loadTaxSettings: (payload) => dispatch(taxSettingsIndex(payload)),
  loadPaymentTerms: (payload) => dispatch(paymentTermsIndex(payload)),
  loadPaymentMethods: (payload) => dispatch(paymentMethodsIndex(payload)),
  loadSuppliers: (payload) => dispatch(suppliersIndex(payload)),
  loadLocations: (payload) => dispatch(locationsIndex(payload)),
  addPurchaseOrder: (payload, purchaseOrderJson, purchaseOrderLinesJson) => dispatch(purchaseOrdersCreate(payload, purchaseOrderJson, purchaseOrderLinesJson, 'restock')),
  markSuggestionComplete: (payload, suggestedOrderId) => dispatch(markComplete(payload, suggestedOrderId)),
  clearPOLines: () => dispatch(reset()),
  loadSuggestedOrder: (payload, suggestedOrderId) => dispatch(findSuggestedPurchaseOrder(payload, suggestedOrderId)),

  quantityUpdate: (payload, itemData, itemKey) => dispatch(purchaseOrderUpdateQuantity(payload, itemData, itemKey)),
  addItem: (payload, itemData) => dispatch(purchaseOrderAddItem(payload, itemData)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewSuggestedPurchaseOrderForm);
